import React, { useState } from "react";
import { Form, Button, Modal } from "antd";
import { gql, useMutation } from "@apollo/client";
import EventInputs from "../inputs/event";

const CRERATEPRODUCT = gql`
  mutation createEvent($createEventInput: CreateEventInput!) {
    createEvent(createEventInput: $createEventInput) {
      id
      name
    }
  }
`;
function AddEvent() {
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const [runCreateProduct, createProduct] = useMutation(CRERATEPRODUCT, {
    onCompleted({ createEvent }) {
      Modal.success({
        content: `${createEvent?.name} به خدمات صفاتک اضافه شد.`,
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: () => form.resetFields(),
      });
    },
    onError(err) {
      console.log("خطا: " + err.message);
      Modal.error({
        title: "مشکلی پیش آمده!",
        content: "لطفا دوباره تلاش کنید!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });
  const doCreateProduct = (createEventInput) => {
    runCreateProduct({
      variables: {
        createEventInput,
      },
    });
  };

  return (
    <>
      <Form layout="vertical" onFinish={doCreateProduct} form={form}>
       <EventInputs error={error} />
        <Button
          type="primary"
          htmlType="submit"
          loading={createProduct.loading && true}
        >
          ثبت خدمت
        </Button>
      </Form>
    </>
  );
}

export default AddEvent;
